import { createSlice } from '@reduxjs/toolkit';

// Initialize state from localStorage
const getInitialState = () => {
    let restaurants = [];
    let selectedRestaurantId = null;

    try {
        const storedRestaurants = localStorage.getItem('restaurants');
        const storedSelectedRestaurant = localStorage.getItem('selectedRestaurant');

        if (storedRestaurants) {
            restaurants = JSON.parse(storedRestaurants);
        }
        if (storedSelectedRestaurant) {
            selectedRestaurantId = storedSelectedRestaurant;
        }
    } catch (error) {
        console.error('Error parsing stored restaurant data:', error);
    }

    return {
        restaurants,
        selectedRestaurantId,
        restaurantsLoaded: false,
    };
};

const restaurantSlice = createSlice({
    name: 'restaurant',
    initialState: getInitialState(),
    reducers: {
        setRestaurants: (state, action) => {
            state.restaurants = action.payload;

            // Sync with localStorage
            try {
                localStorage.setItem('restaurants', JSON.stringify(action.payload));
            } catch (error) {
                console.error('Error saving restaurants to localStorage:', error);
            }
        },
        setSelectedRestaurantId: (state, action) => {
            state.selectedRestaurantId = action.payload;

            // Sync with localStorage
            try {
                if (action.payload) {
                    localStorage.setItem('selectedRestaurant', action.payload);
                } else {
                    localStorage.removeItem('selectedRestaurant');
                }
            } catch (error) {
                console.error('Error saving selected restaurant to localStorage:', error);
            }
        },
        addRestaurant: (state, action) => {
            const restaurant = action.payload;
            const exists = state.restaurants.find(r => r._id === restaurant._id);
            if (!exists) {
                state.restaurants.push(restaurant);

                // Sync with localStorage
                try {
                    localStorage.setItem('restaurants', JSON.stringify(state.restaurants));
                } catch (error) {
                    console.error('Error saving restaurants to localStorage:', error);
                }
            }
        },
        updateRestaurant: (state, action) => {
            const updatedRestaurant = action.payload;
            state.restaurants = state.restaurants.map(r =>
                r._id === updatedRestaurant._id ? updatedRestaurant : r
            );

            // Sync with localStorage
            try {
                localStorage.setItem('restaurants', JSON.stringify(state.restaurants));
            } catch (error) {
                console.error('Error saving restaurants to localStorage:', error);
            }
        },
        setRestaurantsLoaded: (state, action) => {
            state.restaurantsLoaded = action.payload;
        },
        clearRestaurants: (state) => {
            state.restaurants = [];
            state.selectedRestaurantId = null;
            state.restaurantsLoaded = false;

            // Clear localStorage
            try {
                localStorage.removeItem('restaurants');
                localStorage.removeItem('selectedRestaurant');
            } catch (error) {
                console.error('Error clearing restaurant data from localStorage:', error);
            }
        },
    },
});

export const {
    setRestaurants,
    setSelectedRestaurantId,
    setRestaurantsLoaded,
    addRestaurant,
    updateRestaurant,
    clearRestaurants,
} = restaurantSlice.actions;

// Selectors
export const selectRestaurants = (state) => state.restaurant.restaurants;
export const selectRestaurantsLoaded = (state) => state.restaurant.restaurantsLoaded;
export const selectSelectedRestaurantId = (state) => state.restaurant.selectedRestaurantId;
export const selectSelectedRestaurant = (state) => {
    const selectedId = state.restaurant.selectedRestaurantId;
    if (!selectedId) return null;
    return state.restaurant.restaurants.find(r => r._id === selectedId) || null;
};

export default restaurantSlice.reducer;

